




























import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

@Component( {
    computed: mapGetters( {
        signInEmail: 'usersModule/signInEmail'
    } )
} )
export default class BaseLogin extends Vue {
    @Prop( { default: false } ) showCancel!: boolean
    @Prop( { default: true } ) alignCenter!: boolean
    @Prop() cancelCallback!: Function
    email = ''
    invalidEmail = false
    signingIn = false
    signInEmail!: any
    acceptedPrivacyStatement = false

    setEmail() {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        if ( emailPattern.test( this.email ) ) {
            this.invalidEmail = false
            this.signingIn = true
            this.$store.dispatch( 'usersModule/requestSignInLink', this.email )
        } else {
            this.invalidEmail = true
        }
    }

    cancelLogin() {
        this.cancelCallback()
    }
}
